import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { CreditPurchaseViewStore } from "../../store";
import { CreditPurchaseView } from "../view/CreditPurchaseView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type CreditPurchaseModalContentProps = {
  entityId: string;
  mode: "view" | "update";
  onClose: () => void;
};

export const CreditPurchaseModalContent: React.FC<CreditPurchaseModalContentProps> =
  observer(({ entityId, mode, onClose }) => {
    const rootStore = useRootStore();
    const initializedRef = useRef<string | null>(null);

    const storeInfo = useMemo(() => {
      // Default to view mode
      const s = new CreditPurchaseViewStore(rootStore);
      s.isModalMode = true;
      return { store: s, type: "view" as const };
    }, [rootStore]);

    useEffect(() => {
      if (entityId && initializedRef.current !== entityId) {
        initializedRef.current = entityId;
        storeInfo.store.initialize({ id: entityId });
      }
    }, [entityId, storeInfo]);

    useEffect(() => {
      return () => {
        storeInfo.store.destroy();
      };
    }, [storeInfo]);

    const store = storeInfo.store;
    if (store.status === "processing" || store.status === "uninitialized") {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <Box sx={{ p: 2 }}>
        {storeInfo.type === "view" && (
          <CreditPurchaseView
            creditPurchaseViewStore={storeInfo.store as CreditPurchaseViewStore}
          />
        )}
      </Box>
    );
  });
